import { Link } from "react-router-dom";

const AnalyticalToolsContentThree = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Built for Precision. Designed for Every Trader.</h2>
              <p>
                Whether you’re identifying entry points, confirming signals, or
                tracking volatility, The Pips Analytical Tools provide the
                clarity and speed you need to trade smarter. Each feature is
                optimized for real-world trading, empowering you to analyze,
                adapt, and act with confidence across any market condition. With
                seamless integration across platforms, your insights stay
                consistent wherever you trade. Advanced customization options
                also allow you to fine-tune every tool to match your personal
                strategy and trading style
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Discover the Tools
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/resources/analytical_tools/analytical_tools_3.png"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticalToolsContentThree;
